var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMdiInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MDI_instagram",
    "data-name": "MDI / instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_instagram",
    "data-name": "Path / instagram",
    d: "M6.108,2h5.95a4.111,4.111,0,0,1,4.108,4.108v5.95a4.108,4.108,0,0,1-4.108,4.108H6.108A4.111,4.111,0,0,1,2,12.058V6.108A4.108,4.108,0,0,1,6.108,2M5.967,3.417a2.55,2.55,0,0,0-2.55,2.55V12.2a2.548,2.548,0,0,0,2.55,2.55H12.2a2.55,2.55,0,0,0,2.55-2.55V5.967a2.548,2.548,0,0,0-2.55-2.55H5.967M12.8,4.479a.885.885,0,1,1-.885.885.885.885,0,0,1,.885-.885M9.083,5.542A3.542,3.542,0,1,1,5.542,9.083,3.542,3.542,0,0,1,9.083,5.542m0,1.417a2.125,2.125,0,1,0,2.125,2.125A2.125,2.125,0,0,0,9.083,6.958Z",
    transform: "translate(-0.583 -0.583)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiInstagram);
export default __webpack_public_path__ + "static/media/MDI - instagram.df97088799eee90af28e2804d307ceee.svg";
export { ForwardRef as ReactComponent };